import { useState, useEffect } from 'react';
import { Form, Input, Row, Modal, Spin } from 'antd';
import classNames from 'classnames/bind';
import styles from './ReceiveRewarded.module.scss';
import { checkKeyDownNumberInput, getNumberWithCommas } from '~/utils';
import { IMAGES } from '~/assets/assetsPath';
import userAPI from '~/api/UserAPI';
import ReceiveRewardedSuccess from '~/components/ReceiveRewardedSuccess';
import { useParams, useNavigate } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useLocation } from 'react-router-dom';
import rewardAPI from '~/api/RewardAPI';

const cx = classNames.bind(styles);

const ReceiveRewarded = () => {
    //Get 100vh follow browser
    const documentHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
    };
    window.addEventListener('resize', documentHeight);
    documentHeight();

    const navigate = useNavigate();
    const [formReceive] = Form.useForm();
    const [err, setErr] = useState('');
    const [msg, setMsg] = useState('');
    const [isShowSuccessModal, setIsShowSuccessModal] = useState(false);
    const { code } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const [refId, setRefId] = useState('');

    const [value, setValue] = useState('');

    const parseCode = [
        {
            code: 'ogGMxpzr3ybW',
            value: 200,
        },
        {
            code: 'ogGM_pzr3ybW',
            value: 500,
        },
    ];

    useEffect(() => {
        const search = location?.search?.split('?').join('');
        const ref = new URLSearchParams(search).get('ref');
        if (ref) {
            setRefId(ref);
        }
        // eslint-disable-next-line
    }, [location]);

    const handleGetInfoReward = async (data) => {
        try {
            const body = {
                code: data,
            };

            const res = await rewardAPI.getRewardAPI(body);

            if (res?.code === 200) {
                setValue(res?.results?.object?.value);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetInfoReward(code);
        // const temp = parseCode?.filter((x) => x.code === code)[0]?.value;
        // setValue(temp);
        // eslint-disable-next-line
    }, [code]);

    const onAgreeReceive = async (data) => {
        setIsLoading(true);
        try {
            const body = {
                phone: data?.phone,
                code: code,
                ref_id: refId,
            };
            const res = await userAPI.getGiftAPI(body);
            if (res?.code === 200) {
                setMsg(res?.results?.object?.message);
                formReceive.setFieldsValue({ phone: '' });
                // navigate(config.routes.downloadAPP);
                setIsShowSuccessModal(true);
            } else {
                setMsg('');
            }
        } catch (err) {
            if (err?.message) {
                setErr(err?.message);
            }
        }
        setIsLoading(false);
    };

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangNhanThuong');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <Spin spinning={isLoading}>
                <div className={cx('container')}>
                    <div className={cx('form_container')}>
                        <Form onFinish={onAgreeReceive} form={formReceive} style={{ width: '100%' }}>
                            <Form.Item>
                                <Row justify="center">
                                    <div className={cx('logo_section')}>
                                        <img src={IMAGES.ImageLogoGold} alt="logo" />
                                    </div>
                                </Row>
                            </Form.Item>
                            <Form.Item>
                                <div className={cx('bio')}>
                                    <Row justify="center" className={cx('text')}>
                                        DONATE IMMEDIATELY
                                    </Row>
                                    <Row justify="center" className={cx('money')}>
                                        {getNumberWithCommas(value)} d
                                    </Row>
                                    <Row
                                        justify="center"
                                        className={cx('text')}
                                        style={{ color: 'rgba(178, 158, 5, 0.929)' }}
                                    >
                                        FOR FIRST-TIME GUESTS REGISTERING
                                    </Row>
                                </div>
                            </Form.Item>
                            <Row justify="center" className={cx('err')}>
                                {err}
                            </Row>
                            <div className={cx('box_input_btn')}>
                                <Form.Item
                                    name="phone"
                                    rules={[
                                        { required: true, message: 'Please enter phone number' },
                                        {
                                            pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                                            message: 'Wrong phone number format',
                                        },
                                        { min: 10, message: 'Phone number must have 10 digits' },
                                    ]}
                                >
                                    <Input
                                        placeholder="Enter phone number to receive reward"
                                        onKeyDown={checkKeyDownNumberInput}
                                        maxLength={10}
                                        className={cx('item_input')}
                                        autoComplete="off"
                                    />
                                </Form.Item>

                                <Form.Item style={{ marginBottom: '0px' }}>
                                    <button htmlType="submit" className={cx('btn_login')}>
                                        Confirm
                                    </button>
                                </Form.Item>
                            </div>
                            {/* <Form.Item style={{ marginTop: '50px', marginBottom: '10px' }}>
                                <Row justify="center">
                                    <a href="https://vbeauty.app.link/download" target="_blank" rel="noreferrer">
                                        <span className={cx('install_now_text')}>DOWNLOAD APP NOW</span>
                                    </a>
                                </Row>
                            </Form.Item> */}
                        </Form>
                    </div>

                    {isShowSuccessModal && (
                        <Modal
                            centered
                            visible={isShowSuccessModal}
                            onCancel={() => {
                                setIsShowSuccessModal(false);
                                setErr('');
                                // navigate(config.routes.home);
                            }}
                            // maskClosable={false}
                            footer={null}
                            className="otp-modal"
                            width={550}
                            // bodyStyle={{ height: '600px', overflow: 'auto' }}
                        >
                            <div style={{ padding: '20px 20px' }}>
                                <ReceiveRewardedSuccess msg={msg} />
                            </div>
                        </Modal>
                    )}
                </div>
            </Spin>
        </div>
    );
};

export default ReceiveRewarded;
